module.exports = __webpack_public_path__ + "static/img/item3.c4828f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item3.jpg
// module id = oKM4
// module chunks = 0